import { fromJS } from 'immutable';

import { createAsyncAction } from '../utils';

export const loadData = createAsyncAction('LOAD_SUMMARY_DATA');
export const ENVIRONMENT_TYPE_SELECTED = 'SUMMARY_ENVIRONMENT_TYPE_SELECTED';
export const TIME_PERIOD_SELECTED = 'SUMMARY_TIME_PERIOD_SELECTED';
export const PROJECT_GROUP_SELECTED = 'SUMMARY_PROJECT_GROUP_SELECTED';

const initialState = fromJS({
    loading: false,
    error: null,
    total: null,
    successful: null,
    failed: null,
    meanTime: null,
    deploymentDuration: null,
    failedRatio: null,
    projectOrGroup: null,
    environmentType: null,
    timePeriod: null,
    timePeriodInfo: { start: null, end: null }
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case loadData.REQUEST:
            return state
                .update('error', () => null)
                .update('loading', () => true)
                .update('projectOrGroup', () => fromJS(action.payload.projectOrGroup))
                .update('timePeriod', () => fromJS(action.payload.timePeriod))
                .update('environmentType', () => fromJS(action.payload.environmentType))
                .update('timePeriodInfo', () => fromJS(action.payload.timePeriodInfo));
        case loadData.SUCCESS:
            const updatedState = state.update('loading', () => false);
            const keys = Object.getOwnPropertyNames(action.payload);
            return keys.reduce((acc, val) => acc.update(val, () => fromJS(action.payload[val])), updatedState);
        case loadData.FAIL:
            return state
                .update('loading', () => false)
                .update('error', () => action.payload);
        default:
            return state;
    }
}

export function summaryActions($http, api,$q) {
    'ngInject';

    function loadSummaryBlock(name, options, start, end) {
        return $http.post(`${api.restServiceUrlDB}statistics/${name}/${start}/${end}`, options);
    }

    /**
     *
     * @param {object} options: timePeriod, projectOrGroup, environmentType, timePeriod
     * @param {*} blocks
     */
    function loadSummaryBlocks(options, blocks) {
        return dispatch => {
            const { projectOrGroup } = options;
            if (!projectOrGroup)
                return;
            const projectIds = [];
            const groupIds = [];
            if (projectOrGroup.type === 'project') {
                projectIds.push(projectOrGroup.id);
            } else {
                groupIds.push(projectOrGroup.id);
            }

            const requestOptions = {
                environmentTypeIds: Array.isArray(options.environmentType.id) ? options.environmentType.id : [options.environmentType.id],
                projectIds,
                groupIds
            };

            dispatch({
                type: loadData.REQUEST,
                payload: {
                    timePeriod: options.timePeriod,
                    environmentType: options.environmentType,
                    projectOrGroup: options.projectOrGroup,
                    timePeriodInfo: { start: options.start, end: options.end }
                }
            });

            const promises = blocks.map(b => loadSummaryBlock(b, requestOptions, options.start, options.end));
            return $q.all(promises).then(results => {
                const payload = {
                    timePeriod: options.timePeriod,
                    environmentType: options.environmentType,
                    projectOrGroup: options.projectOrGroup,
                    timePeriodInfo: { start: options.start, end: options.end }
                };
                results.forEach((result, index) => {
                    const type = blocks[index];
                    switch (type) {
                        case 'total':
                            payload.total = result.data;
                            break;
                        case 'success':
                            payload.successful = result.data;
                            break;
                        case 'failed':
                            payload.failed = result.data;
                            break;
                        case 'deploymentduration':
                            payload.deploymentDuration = result.data;
                            break;
                        case 'meantime':
                            payload.meanTime = result.data;
                            break;
                        case 'failedratio':
                            payload.failedRatio = result.data;
                            break;
                        default:
                            break;
                    }
                });
                dispatch({ type: loadData.SUCCESS, payload });
            }, error => {
                dispatch({ type: loadData.FAIL, error: true, payload: error.data });
            });
        }
    }

    return { loadSummaryBlocks };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/summary.js